// extracted by mini-css-extract-plugin
export default {"offer":"similar-to-youGkrnr4","offer--exit-active":"similar-to-younET-72","offer--exited":"similar-to-youLiBrV3"};